import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import FormInput from 'components/common/Input';
import LoginButton from 'components/common/Button';
import ErrorMessage from 'components/common/ErrorMessage';
import useUser from 'hooks/useUser';
import { userLoginAction } from 'store/actions/login';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const Login = ({ history }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const requestStatus = useSelector((state) => state.status);

  const { isAuthenticated, isDropShipUser } = useUser();

  useEffect(() => {
    if (isAuthenticated) {
      if (isDropShipUser) {
        history.push('/inventory');
      } else {
        history.push('/forbidden');
      }
    }
  }, [history, isAuthenticated, isDropShipUser]);

  const handleSubmit = useCallback(() => {
    dispatch(
      userLoginAction({
        user: {
          username: email,
          password: password,
        },
      }),
    );
  }, [dispatch, email, password]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePaswordChange = (e) => {
    setPassword(e.target.value);
  };

  useEffect(() => {
    const handleKeydown = (e) => {
      if (e.keyCode === 13 || e.key === 'enter') {
        handleSubmit();
      }
    };

    window.addEventListener('keydown', handleKeydown);
    return () => {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [email, handleSubmit, password]);

  const welcome = 'sign in';

  return (
    <Login.LoginContainer>
      <Login.LoginTitle>
        {welcome}
        <FormInput
          onChange={handleEmailChange}
          placeholder="Username or Email"
          type="email"
          hasValue={email && email.length > 0}
          hasError={requestStatus.hasError}
          zIndex="1"
        />
        <FormInput
          onChange={handlePaswordChange}
          placeholder="Password"
          type="password"
          hasValue={password && password.length > 0}
          hasError={requestStatus.hasError}
        />
        {requestStatus.hasError && requestStatus.errorMessage && (
          <ErrorMessage message={requestStatus.errorMessage} />
        )}
        <Login.ForgotLink to="/forgot-password">Forgot Password</Login.ForgotLink>
        <LoginButton onSubmit={handleSubmit} text="login" />
      </Login.LoginTitle>
      <Login.Alias>ALIAS BY GOAT GROUP</Login.Alias>
    </Login.LoginContainer>
  );
};

Login.LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 394px;
  width: 290px;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;
Login.LoginTitle = styled.h1`
  font-weight: 500;
  font-family: ${FONTS.default};
  width: 289px;
  font-size: 20px;
  line-height: 24px;
  color: ${COLORS.primaryText};
  text-transform: capitalize;
`;

Login.ForgotLink = styled(Link)`
  color: ${COLORS.primaryText};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  font-family: ${FONTS.default};
  margin-top: 8px;
  justify-content: start;
  display: flex;
  font-weight: 400;

  &:hover {
    text-decoration: underline;
    color: ${COLORS.primaryText};
  }
`;

Login.Alias = styled.div`
  font-size: 12px;
  letter-spacing: 3px;
  color: ${COLORS.secondaryText};
  position: absolute;
  bottom: 33px;
`;

export default withRouter(Login);
